import createReactClass from "create-react-class";

export default function(dependencies) {

    const tools = dependencies.tools;

    const Image = createReactClass({
        render() {
            var field = this.props.field;
            var apiStatus = field.state.api;
            return ( 
                <div className="lz-input-wrapper">
                <label htmlFor={tools.uniqueId(field.config.id)}>{field.config.label || ""}</label>
                <span className="lz-extratext">{field.config.extraText || ""}</span>
                <div className="lz-image"><img src={field.config.imageSrc} /></div>
                    {
                        field.config.imageDescription ?  
                            <div className="lz-alert" style={{"display": "block"}} dangerouslySetInnerHTML ={{__html: field.config.imageDescription}}>
                    </div> 
                            : null
                    }
                </div>
                );
        },
    });

    return {
        html: Image,
    };
};
